import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { setUserEmail, setUserName } from '../../app/features/userSlice';
import { getInfoUserD2L } from '../../services/getInfoUserD2L';

const D2lCallback = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { search } = useLocation();
	const { institutionCode } = useSelector((state) => state.institution);

	useEffect(() => {
		const params = new URLSearchParams(search);
		const code = params.get('code');

		if (!code) {
			navigate('/', { replace: true });
			return;
		}

		getInfoUserD2L(code, institutionCode).then((res) => {
			if (res?.data) {
				const { firstname, lastname, email } = res.data;
				dispatch(setUserName(`${firstname} ${lastname}`.trim()));
				dispatch(setUserEmail(email));
				navigate('/articles', { replace: true });
			} else {
				navigate('/', { replace: true });
			}
		});
	}, [search, navigate, dispatch]);

	return null;
};

export default D2lCallback;
